
<template>
  <div class="legel_audit">
    <Modal
      v-model="showModal"
      :closable="false"
      :mask-closable="false"
      title="编辑法务审核人员配置"
      width="600"
    >
      <Spin
        v-if="getLoading"
        size="large"
        fix
      />
      <Form
        ref="formValidate"
        :model="formData"
        :rules="formRule"
        :label-width="100"
      >
        <FormItem
          label="配置名称"
          prop="name"
        >
          <Input
            v-model="formData.name"
            placeholder="请输入配置名称"
          />
        </FormItem>
        <FormItem 
          label="人员列表"
          prop="content"
        >
          <div>
            <Tag
              v-for="(item,index) in formData.content"
              :key="item.id"
              style="margin:0px 5px"
              type="border"
              closable
              :color="item.active? 'primary':'warning'"
              @on-close="deletItem(index)"
            >
              <Poptip
                confirm
                :title="item.active?'是否将人员置于暂无法审核状态？':'是否将人员置于可正常审核状态？'"
                placement="top"
                @on-ok="changePersonStatus(index)"
              >
                <span style="cursor: pointer">
                  {{ item.account }}
                </span>
              </Poptip>
            </Tag>
            <div 
              style="width:60px;display:inline-block"
            >
              <CustomerSelector
                :transfer="true"
                type="text"
                width="300"
                height="500"
                @on-change="addNewPerson"
              >
                <Button
                  size="small" 
                  type="primary"
                >
                  新增
                </Button>
              </CustomerSelector>            
            </div>            
          </div>
        </FormItem>
      </Form>
      <template v-slot:footer>
        <i-button
          type="text"
          @click.native="closeModal"
        >
          取消
        </i-button>
        <i-button
          :loading="subMitDataLoading"
          type="primary"
          @click.native="submit('formValidate')"
        >
          保存
        </i-button>
      </template>
    </Modal>
  </div>
</template>
<script>
  import CustomerSelector from './../../components/customer/selector'
  import { RULE_VALIDATE,KEY_NAME, DEFAULT_DATA } from './constants'
  import { getConfigApi,submitConfigApi } from './editorServicer'
    export default {
      components:{ CustomerSelector } ,
        props: {
          value: {
            type: Boolean,
            default:() => false
          },
        },
        data (){
            return {
                formRule: RULE_VALIDATE,
                showModal: this.value,
                getLoading: false,
                subMitDataLoading: false,
                formData:{
                  name:'',
                  key_name:'',
                  content:[]
                }
            }
        },
        watch: { 
             value (val) {
               this.showModal = val;
               if(val) {
                 this.subMitDataLoading = false
                 this.getLoading = true
                 const obj = Util.clone(DEFAULT_DATA)
                 getConfigApi.call(this,{ key_name: KEY_NAME },() => {
                  this.closeModal()
                  this.getLoading = false
                 }).then(data => {
                   Object.keys(obj).forEach(key => {
                     this.$set(this.formData,key,data[key]||obj[key])
                   })
                   this.getLoading = false
                 })
               } else {
                 this.formData = Util.clone(DEFAULT_DATA)
               }
             }
        },
        methods: {
          addNewPerson ({id,account,active=true}) {
            if(this.formData.content.some(item => item.id===id)) {
              this.$Message.warning(`${account}已存在列表中`)
              return
            }
             this.formData.content.push({ id,account,active })
          },
          deletItem (index) {
             this.formData.content.splice(index,1)
          },
          submit (name) {
              this.$refs[name].validate((success) => {
                    if (success) {
                      this.subMitDataLoading = true
                      submitConfigApi.call(this,this.formData).then((res) => {
                        console.log(res)
                        if(res.code===1) {
                           this.closeModal()
                        }
                        this.subMitDataLoading = false
                      }).catch(() => {
                        this.subMitDataLoading = false
                      })
                    }
                })
          },
          closeModal () {
            this.$emit('closeModal',false)
          },
          changePersonStatus (index) {
              this.formData.content[index].active = !this.formData.content[index].active
          }
        }
    }
</script>
